export default __webpack_public_path__ + "static/media/aiadmk.4d1c3b4c.webp";